import { Component } from '@angular/core';
import { TopBarComponent } from '../layout/top-bar/top-bar.component';
import { FooterComponent } from '../layout/footer/footer.component';
import { UpdateNotificationComponent } from './update-notification/update-notification.component';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-main-layout',
    imports: [CommonModule, TopBarComponent, FooterComponent, UpdateNotificationComponent, RouterOutlet],
    template: `
    <div class="layout-wrapper">
      <app-top-bar></app-top-bar>
      <div class="main-content">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
      <app-update-notification></app-update-notification>
    </div>
  `,
    styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {}
